.container {
  font-size: var(--ns-font-size-4);
  text-align: center;
}

.message {
  font-size: 16px;
  font-weight: 700;
  margin-bottom: 0;
}

.suggestionsTitle {
  font-size: 14px;
  margin-bottom: 1rem;
}

.suggestionsList {
  display: inline-block;
  margin: var(--ns-space-2) 0 0;
  padding: 0;
  list-style: none;
  text-align: left;
  font-size: 14px;
}

.suggestionsList li::before {
  content: "- ";
}

.links {
  display: flex;
  justify-content: center;
  gap: 5px;
  margin-top: var(--ns-space-5);
}

.link {
  color: #e04e00;
  text-decoration: underline;
  text-transform: uppercase;
  font-size: 14px;
  font-weight: 700;
  text-decoration: none;
}

.link:not(:last-child)::after {
  content: "|";
  margin-left: 5px;
  text-decoration: none;
  color: inherit;
}

.searchAgainForm {
  display: flex;
  align-items: stretch;
  gap: 5px;
  max-width: 360px;
  margin: var(--ns-space-5) auto 0;
}

.searchAgainInput {
  flex: 1;
  min-width: 0;
  height: 20px;
  box-sizing: border-box;
  border: 1px solid var(--ns-color-black);
  border-radius: 0;
  background-color: var(--ns-color-white);
  padding: 0 var(--ns-space-2);
  font-size: var(--ns-font-size-4);
  font-family: inherit;
  color: var(--ns-color-black);
}

.searchAgainInput:focus {
  outline: 0;
  box-shadow:
    inset 0 0 0 1px var(--ns-color-primary-light),
    0 0 0 var(--ns-shadow-offset-medium) var(--ns-color-grey);
}

.searchAgainButton {
  height: 20px;
  box-sizing: border-box;
  padding: 0 var(--ns-space-2);
  border-radius: 0;
  background-color: var(--ns-color-black);
  color: var(--ns-color-white);
  text-transform: uppercase;
  font-weight: 600;
  white-space: nowrap;
}

.searchAgainButton:hover {
  background-color: var(--ns-color-grey-dark);
}
